// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6t7E0","label":"styles_label__1Z6tA"};